import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

type SwiperRuntime = {
    Swiper: typeof Swiper;
    Navigation: typeof Navigation;
    Pagination: typeof Pagination;
};

declare global {
    interface Window {
        StsSwiperRuntime?: SwiperRuntime;
    }
}

if (typeof window !== 'undefined') {
    window.StsSwiperRuntime = {
        Swiper,
        Navigation,
        Pagination,
    };
}

export {};
